<template>
  <div v-if="hasIcon" v-html="require(`@/assets/svg/${this.icon}.svg`)"></div>
</template>

<script>
import { EXTRAS_NAME } from '@/constants';

export default {
  name: 'SvgIcon',
  props: {
    icon: {
      type: String,
      required: true,
    },
  },
  computed: {
    hasIcon() {
      return this.icon !== EXTRAS_NAME.toLowerCase();
    },
  },
};
</script>

<style scoped>
div {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/SvgIcon.vue